<template>
  <b-modal
    :visible="value"
    title="Crear Sucursal"
    size="lg"
    hide-footer
    centered
    @change="modalChangeEvent"
  >

    <BranchForm
      :data="formData"
      :errors="formErrors"
      @update="updateForm"
    />

    <div class="mt-4 text-right">
      <BfButton
        variant="secondary"
        class="mr-3"
        @click="modalChangeEvent(false)"
      >
        Cancelar
      </BfButton>
      <BfButton @click="saveFormData">
        Guardar y seleccionar para el encargo
      </BfButton>
    </div>
  </b-modal>
</template>

<script>
import BranchForm from '@/components/FormGroups/BranchForm';
import { branchAPI } from '@/api';

export default {
  name: 'CreateBranchModal',

  data() {
    return {
      formData: {},
    };
  },

  async created() {
    const { data } = await branchAPI.preCreate();
    this.formData = data;
  },

  props: {
    formErrors: {
      type: Object,
    },

    value: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    updateForm({ key, value }) {
      this.formData = {
        ...this.formData,
        [key]: value,
      };
    },
    modalChangeEvent(visible) {
      this.$emit('input', visible);
    },

    saveFormData() {
      this.$emit('update', this.formData);
    },
  },

  components: {
    BranchForm,
  },
};
</script>
